import Vue from 'vue';
import {
  IonicVueRouter
} from '@ionic/vue';
import Home from '@/views/Home.vue';
import Specialties from '@/views/Specialties.vue';
import Detail from '@/views/Detail.vue';
import Schedule from '@/views/Schedule.vue';

Vue.use(IonicVueRouter);

export default new IonicVueRouter({
  base: './',
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/specialties/',
    name: 'specialties',
    component: Specialties,
    props: false,
  },
  {
    path: '/detail/',
    name: 'detail',
    component: Detail,
    props: false,
  },
  {
    path: '/schedule/',
    name: 'schedule',
    component: Schedule,
    props: false,
  }
  ]
});
